"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMealBreakValidationDateTimes = void 0;
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../utils/DateManagement");
const PunchTile_1 = require("../../components/PunchTile");
const logger_1 = require("../../logger");
const MEAL_BREAK_VALIDATION_DURATION = 30;
const VALID_DURATION = 31;
const getMealBreakValidationDateTimes = (newPunchDT, oldPunchDT = '', punchWithTimespans = []) => {
    const mealBreakValidationDateTimes = new Array();
    const distanceInMin = getDistanceInMin(newPunchDT, oldPunchDT, punchWithTimespans);
    if (distanceInMin && distanceInMin < MEAL_BREAK_VALIDATION_DURATION) {
        const benchmarkPunch = getbenchmarkPunch(punchWithTimespans, distanceInMin);
        if (benchmarkPunch) {
            const convertedPunchDT = (0, DateManagement_1.addMinutes)(benchmarkPunch.timestamp, distanceInMin);
            mealBreakValidationDateTimes.push({
                timestamp: convertedPunchDT,
                timezone: benchmarkPunch.timezone
            });
        }
        else {
            logger_1.logger.info('Benchmark outPunch not found, will skip MealLockoutValidation');
        }
    }
    return mealBreakValidationDateTimes;
};
exports.getMealBreakValidationDateTimes = getMealBreakValidationDateTimes;
const getDistanceInMin = (newPunchDT, oldPunchDT, punchWithTimespans) => {
    const { punchArray, newPunchDTIndex } = getPunchArrayInOrder(newPunchDT, oldPunchDT, punchWithTimespans);
    if (!punchArray.length) {
        return VALID_DURATION;
    }
    let distanceToPrev = VALID_DURATION;
    let distanceToNext = VALID_DURATION;
    if (newPunchDTIndex > 0 && newPunchDTIndex < punchArray.length) {
        if (punchArray[newPunchDTIndex - 1].type !== punchArray[newPunchDTIndex].type) {
            distanceToPrev = (0, DateManagement_1.getMinutesDifference)(punchArray[newPunchDTIndex - 1].dateTime, newPunchDT);
            distanceToNext = (0, DateManagement_1.getMinutesDifference)(newPunchDT, punchArray[newPunchDTIndex].dateTime);
        }
        else {
            const prevOutPunch = findPunchWithType(punchArray, newPunchDTIndex - 1, -1, PunchTile_1.PunchType.out);
            const nextInPunch = findPunchWithType(punchArray, newPunchDTIndex, 1, PunchTile_1.PunchType.in);
            distanceToPrev = prevOutPunch
                ? (0, DateManagement_1.getMinutesDifference)(prevOutPunch, newPunchDT)
                : VALID_DURATION;
            distanceToNext = nextInPunch
                ? (0, DateManagement_1.getMinutesDifference)(newPunchDT, nextInPunch)
                : VALID_DURATION;
        }
    }
    else if (newPunchDTIndex === 0) {
        const nextInPunch = findPunchWithType(punchArray, newPunchDTIndex, 1, PunchTile_1.PunchType.in);
        distanceToNext = nextInPunch
            ? (0, DateManagement_1.getMinutesDifference)(newPunchDT, nextInPunch)
            : VALID_DURATION;
    }
    else {
        const prevOutPunch = findPunchWithType(punchArray, newPunchDTIndex - 1, -1, PunchTile_1.PunchType.out);
        distanceToPrev = prevOutPunch
            ? (0, DateManagement_1.getMinutesDifference)(prevOutPunch, newPunchDT)
            : VALID_DURATION;
    }
    return Math.min(distanceToPrev, distanceToNext);
};
const findPunchWithType = (punchArray, beginIndex, step, type) => {
    let punch = null;
    let index = beginIndex;
    while (!punch && index >= 0 && index < punchArray.length) {
        if (punchArray[index].type == type) {
            punch = punchArray[index].dateTime;
        }
        index += step;
    }
    return punch;
};
const getPunchArrayInOrder = (newPunchTimestamp, oldPunchTimestamp, punchWithTimespans) => {
    const newPunchDT = luxon_1.DateTime.fromISO(newPunchTimestamp);
    const oldPunchDT = luxon_1.DateTime.fromISO(oldPunchTimestamp);
    const punchArray = punchWithTimespans
        .reduce((punchArrayAcc, timespan) => {
        var _a, _b;
        const inTimestamp = (_a = timespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime.timestamp;
        const outTimestamp = (_b = timespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime.timestamp;
        if (inTimestamp &&
            luxon_1.DateTime.fromISO(inTimestamp).toMillis() !== oldPunchDT.toMillis()) {
            punchArrayAcc.push({
                type: PunchTile_1.PunchType.in,
                dateTime: inTimestamp
            });
        }
        if (outTimestamp &&
            luxon_1.DateTime.fromISO(outTimestamp).toMillis() !== oldPunchDT.toMillis()) {
            punchArrayAcc.push({
                type: PunchTile_1.PunchType.out,
                dateTime: outTimestamp
            });
        }
        return punchArrayAcc;
    }, [])
        .sort((punchA, punchB) => luxon_1.DateTime.fromISO(punchA.dateTime).toMillis() -
        luxon_1.DateTime.fromISO(punchB.dateTime).toMillis());
    let newPunchDTIndex = 0;
    punchArray.forEach((punch, index) => {
        if (newPunchDT > luxon_1.DateTime.fromISO(punch.dateTime)) {
            newPunchDTIndex = index + 1;
        }
    });
    return {
        punchArray,
        newPunchDTIndex
    };
};
const getbenchmarkPunch = (punchWithTimespans, distance) => {
    var _a, _b, _c;
    const benchmarkOutPunch = punchWithTimespans.find((timespan, index, timespanArray) => {
        var _a, _b, _c;
        if (index == timespanArray.length - 1) {
            return false;
        }
        const currOutDT = (_a = timespan === null || timespan === void 0 ? void 0 : timespan.endSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime.timestamp;
        const nextInDT = (_c = (_b = timespanArray[index + 1]) === null || _b === void 0 ? void 0 : _b.startSpan) === null || _c === void 0 ? void 0 : _c.punchDateTime.timestamp;
        return (currOutDT &&
            nextInDT &&
            (0, DateManagement_1.getMinutesDifference)(currOutDT, nextInDT) > distance);
    });
    const lastOutPunch = (_b = (_a = punchWithTimespans[punchWithTimespans.length - 1]) === null || _a === void 0 ? void 0 : _a.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime;
    return ((_c = benchmarkOutPunch === null || benchmarkOutPunch === void 0 ? void 0 : benchmarkOutPunch.endSpan) === null || _c === void 0 ? void 0 : _c.punchDateTime) || lastOutPunch;
};
